import { useNavigate } from "react-router-dom";

import useSessionStateSync from "@hooks/useSessionStateSync";

import { CheckoutPageRoutesEnum } from "@ts/enums/CheckoutPageRoutesEnum";
import { CheckoutStateInterface } from "@ts/interfaces/Misc/state/CheckoutStateInterface";

const useCheckoutPageRedirection = () => {
    const navigate = useNavigate();

    const [, sessionState] = useSessionStateSync<CheckoutStateInterface>();

    const pageRedirection = () => {
        if (sessionState.checkout?.checkoutPurchasingAddon) {
            navigate(CheckoutPageRoutesEnum.ADDON_SELECT_PAGE);
        }
    };

    return pageRedirection;
};

export default useCheckoutPageRedirection;
